import { render, staticRenderFns } from "./AdminAdmin.vue?vue&type=template&id=7d81017a"
import script from "./AdminAdmin.vue?vue&type=script&lang=js"
export * from "./AdminAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports